import { render } from "./BottomQuestionView.vue?vue&type=template&id=587b5f68"
import script from "./BottomQuestionView.vue?vue&type=script&lang=js"
export * from "./BottomQuestionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__